import { IAjaxConfig } from '../helpers';
/**
 *  EnumApiBPmproduct API 地址
 *  @swagger  b2bSystem => http://bpportalsystemsit.earth.xpaas.lenovo.com/swagger-ui.html#/
 */
export class EnumApiUsersvr {
  /**
   * @dec 获取市场资讯,资料，新闻，等
   */
  readonly usersvr_bizNews: IAjaxConfig = {
    // url: '/api/gateway/content-bff/v1/news/list',
    url: '/api/gateway/content-bff/v2/news/list',
    method: 'post',
    // awaitAuthenticated: false,
    // cache: true
    fos: true,
  };
  /**
   * @dec 获取市场活动,资料，新闻，详情
   */
  readonly usersvr_bizNews_details: IAjaxConfig = {
    url: '/api/gateway/content-bff/v2/news/{id}',
    // url: '/api/gateway/content-bff/v1/news/{id}',
    awaitAuthenticated: false,
    fos: true,
  };
  /**
   * @dec 获取文件
   */
  readonly usersvr_bizNews_fetch: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-usersvr/v2/bizNews/fetch/{id}',
    loading: true,
  };
  /**
   * @dec 资料枚举
   */
  readonly usersvr_channel_enum: IAjaxConfig = {
    url: '/api/gateway/content-bff/v1/news/type/channel_enum',
    // url: "/api/gateway/pcsd-bp-customer-usersvr/v2/bizNews/channel_enum",
    cache: true,
  };
  /**
   * @dec 资料枚举
   */
  readonly usersvr_channels: IAjaxConfig = {
    url: '/api/gateway/content-bff/v2/content/type',
    // url: '/api/gateway/content-bff/v1/news/type/channels/',
    cache: true,
  };
  /**
   * 培训赋能校验用户是否已激活
   * @type {IAjaxConfig}
   * @memberof EnumApiIdass
   */
  readonly usersvr_activation_check: IAjaxConfig = {
    // url: '/api/gateway/idaas-protect/yxt/user/screen/check',
    url: '/api/gateway/bp-integrate-cultivate/train/user/activation/check',
    method: 'get',
  };
  /**
   * 确认完善个人信息，下次无需再弹
   * @type {IAjaxConfig}
   * @memberof EnumApiIdass
   */
  readonly idass_save_yxt_user: IAjaxConfig = {
    // url: '/api/gateway/idaas-protect/yxt/user/screen/save',
    url: '/api/gateway/bp-integrate-cultivate/yxt/user/screen/save',
    method: 'post',
  };
  /**
   * @dec 用户同意授权确认
   */
  readonly usersvr_authorize_agree: IAjaxConfig = {
    // url: '/api/gateway/content-bff/v1/authorize/agree',
    url: '/api/gateway/bp-integrate-cultivate/train/user/authorized/agree',
    method: 'post',
  };
  /**
   * @dec 查询渠道用户培训主体
   */
  readonly usersvr_principalPart_query: IAjaxConfig = {
    url: '/api/gateway/bp-integrate-cultivate/train/user/principalPart/query',
  };
  /**
   * 渠道用户培训主体选择确认
   */
  readonly usersvr_principalPart_choice: IAjaxConfig = {
    url: '/api/gateway/bp-integrate-cultivate/train/user/principalPart/choice/validation',
    method: 'post',
  };
  /**
   * @dec 省
   */
  readonly usersvr_provinces: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-usersvr/v1/area/provinces',
    cache: true,
  };
  /**
   * @dec 市
   */
  readonly usersvr_cities: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-usersvr/v1/area/cities/{citycode}',
    cache: true,
  };
  /**
   * @dec 区
   */
  readonly usersvr_district: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-usersvr/v1/area/district/{citycode}',
    cache: true,
  };
  /**
   * @dec 获取省市区地址 限制
   */
  readonly usersvr_address: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-bffsvr/v1/basic/codeTable',
    method: 'post',
    cache: true,
  };

  /**
   * @dec 个人中心-商机记录
   */
  readonly usersvr_business_list: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-usersvr/v1/appointment/customer/listForPage',
    method: 'post',
  };

  /**
   * @dec 首页-招投标列表
   */
  readonly usersvr_noticeList: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-usersvr/v1/purchase/listForPage',
    awaitAuthenticated: false,
    cache: true,
    method: 'post',
  };

  /**
   * @dec 首页-获取招投标公告详情
   */
  readonly usersvr_noticeDetail: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-usersvr/v1/purchase/{id}',
    awaitAuthenticated: false,
  };

  /**
   * @dec 首页-
   * 政策公告 sectionOneId:A005 pageSize:100 pagenumber:1 isTop:1
   * 市场活动 sectionOneId:A001 pageSize:3 pagenumber:1 sectionTwoId:C008 isTop:1 status:1
   */
  //   readonly usersvr_publicList: IAjaxConfig = {
  //     url: '/api/gateway/pcsd-bp-customer-usersvr/v2/bizNews',
  // }

  /**
   * @dec 首页-活动预告
   */
  readonly usersvr_commingActivityList: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-activity-bff/public/v2/activity/info/upcomingList',
    method: 'post',
  };

  /**
   * @dec 根据登陆的地址获取sales的信息
   */
  readonly usersvr_salesInfo: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-usersvr/v2/sales/findByCity',
  };

  /**
   * @dec 首页商机提交
   */
  readonly usersvr_submitbusiness: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-usersvr/v1/appointment/save',
    method: 'post',
  };

  /**
   * @dec 根据token查询ISG用户基本信息
   */
  readonly bffsvr_isg_user: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-usersvr/v2/user/isg/info',
    method: 'get',
    loading: true,
    awaitAuthenticated: false,
  };
  /**
   * @dec 修改 ISG 用户基本信息
   */
  readonly bffsvr_isg_updateUser: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-usersvr/v2/user/isg/update',
    method: 'POST',
  };

  /**
   * @dec 根据userId查询sales的bu
   */
  readonly bffsvr_get_sales_by_userid: IAjaxConfig = {
    url: '/api/gateway/pcsd-bp-customer-usersvr/v2/sales/bu/userId/get?userId={userId}',
    method: 'get',
  };
  /**
   * @dec 根据userId查询渠道意向伙伴的bu
   */
  readonly bffsvr_get_partner_by_userid: IAjaxConfig = {
    url: '/api/gateway/partner-bff/public/partner/label/get?userId={userId}',
    method: 'get',
  };

  /**
   * @dec 维护用户信息
   */
  readonly integrate_userinfo_update: IAjaxConfig = {
    url: '/api/gateway/bp-integrate-cultivate/user/info/change',
    method: 'put',
    loading: true,
    awaitAuthenticated: false,
  };
}
